export default __webpack_public_path__ + "static/media/skill-beat-choice.07ffe528.svg";